var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill twitter",
    width: 14.409,
    height: 11.688,
    viewBox: "0 0 14.409 11.688",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.563,13.688a8.331,8.331,0,0,0,8.405-8.405v-.4a6.507,6.507,0,0,0,1.441-1.521,6.645,6.645,0,0,1-1.681.48,3.115,3.115,0,0,0,1.281-1.6,7.343,7.343,0,0,1-1.841.72A2.859,2.859,0,0,0,48.006,2a3.008,3.008,0,0,0-2.962,2.962,1.561,1.561,0,0,0,.08.64A8.276,8.276,0,0,1,39.041,2.48,3.066,3.066,0,0,0,38.64,4a3.181,3.181,0,0,0,1.281,2.482,2.7,2.7,0,0,1-1.361-.4h0a2.926,2.926,0,0,0,2.4,2.882,2.468,2.468,0,0,1-.8.08,1.362,1.362,0,0,1-.56-.08,3.033,3.033,0,0,0,2.8,2.081,6.044,6.044,0,0,1-3.682,1.281,2.216,2.216,0,0,1-.72-.08,7.556,7.556,0,0,0,4.563,1.441",
    transform: "translate(-38 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.4621c8da.svg";
export { ForwardRef as ReactComponent };